/**
 * ToastContext - Cho phép mọi component trong cây React gọi addToast()
 * mà không cần prop drilling.
 *
 * Sử dụng:
 *   1. App.tsx wrap toàn bộ với <ToastProvider value={addToast}>
 *   2. Component con: const toast = useToast(); toast('Đã lưu!', 'success');
 *
 * Fallback: nếu không có Provider (hiếm gặp), trả no-op để tránh crash.
 */

import React, { createContext, useContext } from 'react';

export type ToastType = 'success' | 'error' | 'info';
export type ToastFn = (message: string, type?: ToastType) => void;

const ToastContext = createContext<ToastFn>(
    // No-op fallback (chỉ log warning trong dev)
    (message, type) => {
        if (typeof console !== 'undefined' && console.warn) {
            console.warn('[Toast] Provider not mounted. Message:', type, message);
        }
    }
);

export const ToastProvider: React.FC<{ value: ToastFn; children: React.ReactNode }> = ({ value, children }) => {
    return <ToastContext.Provider value={value}>{children}</ToastContext.Provider>;
};

export function useToast(): ToastFn {
    return useContext(ToastContext);
}
